import { getYearNumber } from './date_utils.js';

export const logError = error => {
    console.log('Internal Error', error.message);
};

export const STATES = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'District of Columbia',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
    'American Samoa',
    'Guam',
    'Northern Mariana Islands',
    'Puerto Rico',
    'U.S. Virgin Islands',
];

// Must stay in step with NAME_SUFFIXES in apps/backend/valur/constants.py.
export const NAME_SUFFIXES = [
    'Jr.',
    'Sr.',
    'II',
    'III',
    'IV',
    'V',
    'VI',
    'VII',
    'VIII',
    'IX',
    'X',
    'MD',
    'PhD',
    'Esq.',
];

// VSelect/Reka reserve "" for clearing, so "no suffix" needs a real sentinel.
export const NAME_SUFFIX_NONE = '__none__';

export const BENEFICIARY_RELATION_OPTIONS = [
    { key: 'child', title: 'Child' },
    { key: 'cousin', title: 'Cousin' },
    { key: 'friend', title: 'Friend' },
    { key: 'grandchild', title: 'Grandchild' },
    { key: 'great_grandchild', title: 'Great grandchild' },
    { key: 'niece_or_nephew', title: 'Niece/Nephew' },
    { key: 'parent', title: 'Parent' },
    { key: 'sibling', title: 'Sibling' },
    { key: 'spouse', title: 'Spouse' },
    { key: 'other', title: 'Other' },
];

// No roman numerals: "Malcolm X" is a surname and a flat string cannot tell them apart.
export const UNAMBIGUOUS_NAME_SUFFIXES = ['Jr.', 'Sr.', 'MD', 'PhD', 'Esq.'];

export const STATES_ABBR = {
    Arizona: 'AZ',
    Alabama: 'AL',
    Alaska: 'AK',
    Arkansas: 'AR',
    California: 'CA',
    Colorado: 'CO',
    Connecticut: 'CT',
    Delaware: 'DE',
    'District of Columbia': 'DC',
    Florida: 'FL',
    Georgia: 'GA',
    Hawaii: 'HI',
    Idaho: 'ID',
    Illinois: 'IL',
    Indiana: 'IN',
    Iowa: 'IA',
    Kansas: 'KS',
    Kentucky: 'KY',
    Louisiana: 'LA',
    Maine: 'ME',
    Maryland: 'MD',
    Massachusetts: 'MA',
    Michigan: 'MI',
    Minnesota: 'MN',
    Mississippi: 'MS',
    Missouri: 'MO',
    Montana: 'MT',
    Nebraska: 'NE',
    Nevada: 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    Ohio: 'OH',
    Oklahoma: 'OK',
    Oregon: 'OR',
    Pennsylvania: 'PA',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    Tennessee: 'TN',
    Texas: 'TX',
    Utah: 'UT',
    Vermont: 'VT',
    Virginia: 'VA',
    Washington: 'WA',
    'West Virginia': 'WV',
    Wisconsin: 'WI',
    Wyoming: 'WY',
    'American Samoa': 'AS',
    Guam: 'GU',
    'Northern Mariana Islands': 'MP',
    'Puerto Rico': 'PR',
    'U.S. Virgin Islands': 'VI',
};

export const STATE_HIGH_TAX = {
    Alabama: false,
    Alaska: false,
    Arizona: false,
    Arkansas: false,
    California: true,
    Colorado: false,
    Connecticut: true,
    Delaware: false,
    'District of Columbia': true,
    Florida: false,
    Georgia: false,
    Hawaii: true,
    Idaho: false,
    Illinois: true,
    Indiana: false,
    Iowa: false,
    Kansas: false,
    Kentucky: false,
    Louisiana: false,
    Maine: true,
    Maryland: true,
    Massachusetts: true,
    Michigan: false,
    Minnesota: true,
    Mississippi: false,
    Missouri: false,
    Montana: false,
    Nebraska: false,
    Nevada: false,
    'New Hampshire': false,
    'New Jersey': true,
    'New Mexico': false,
    'New York': true,
    'North Carolina': false,
    'North Dakota': false,
    Ohio: false,
    Oklahoma: false,
    Oregon: true,
    Pennsylvania: false,
    'Rhode Island': true,
    'South Carolina': false,
    'South Dakota': false,
    Tennessee: false,
    Texas: false,
    Utah: false,
    Vermont: true,
    Virginia: false,
    Washington: false,
    'West Virginia': false,
    Wisconsin: false,
    Wyoming: false,
    'American Samoa': false,
    Guam: false,
    'Northern Mariana Islands': false,
    'Puerto Rico': false,
    'U.S. Virgin Islands': false,
};

export const STATE_TAXES = {
    Arizona: 8,
    Alabama: 5,
    Alaska: 0,
    Arkansas: 5.9,
    California: 13.3,
    Colorado: 4.55,
    Connecticut: 6.99,
    Delaware: 6.6,
    'District of Columbia': 8.95,
    Florida: 0,
    Georgia: 5.75,
    Hawaii: 11,
    Idaho: 6.925,
    Illinois: 4.95,
    Indiana: 3.23,
    Iowa: 8.53,
    Kansas: 5.7,
    Kentucky: 5,
    Louisiana: 6,
    Maine: 7.15,
    Maryland: 5.75,
    Massachusetts: 5,
    Michigan: 4.25,
    Minnesota: 9.85,
    Mississippi: 5,
    Missouri: 5.4,
    Montana: 6.9,
    Nebraska: 6.84,
    Nevada: 0,
    'New Hampshire': 5,
    'New Jersey': 10.75,
    'New Mexico': 5.9,
    'New York': 12.71,
    'North Carolina': 5.25,
    'North Dakota': 2.9,
    Ohio: 4.797,
    Oklahoma: 5,
    Oregon: 9.9,
    Pennsylvania: 3.07,
    'Rhode Island': 5.99,
    'South Carolina': 7,
    'South Dakota': 0,
    Tennessee: 0,
    Texas: 0,
    Utah: 4.95,
    Vermont: 8.75,
    Virginia: 5.75,
    Washington: 6,
    'West Virginia': 6.5,
    Wisconsin: 7.65,
    Wyoming: 0,
    'American Samoa': 0,
    Guam: 0,
    'Northern Mariana Islands': 0,
    'Puerto Rico': 0,
    'U.S. Virgin Islands': 0,
};

export const FILING_STATUS_SINGLE = 'single';
export const FILING_STATUS_MARRIED_FILING_JOINTLY = 'married_filing_jointly';
export const FILING_STATUS_MARRIED_FILING_SEPARATELY = 'married_filing_separately';
export const FILING_STATUS_HEAD_OF_HOUSEHOLD = 'head_of_household';
export const FILING_STATUSES = {
    [FILING_STATUS_SINGLE]: 'Single',
    [FILING_STATUS_MARRIED_FILING_JOINTLY]: 'Married, filing jointly',
    [FILING_STATUS_MARRIED_FILING_SEPARATELY]: 'Married, filing separately',
    [FILING_STATUS_HEAD_OF_HOUSEHOLD]: 'Head of household',
};

export const DEPRECIATION_CAP = {
    [FILING_STATUS_SINGLE]: 256000,
    [FILING_STATUS_MARRIED_FILING_JOINTLY]: 512000,
    [FILING_STATUS_MARRIED_FILING_SEPARATELY]: 256000,
    [FILING_STATUS_HEAD_OF_HOUSEHOLD]: 256000,
};

export const MENU_ADMIN_ITEMS = {
    CalculatorsDashboard: Symbol('operations-calculators-dashboard'),
    DocumentValidation: Symbol('operations-document-validation'),
    CustodianStatements: Symbol('operations-custodian-statements'),
    Form5227Review: Symbol('operations-form-5227-extraction'),
    Operations: Symbol('operations'),
    PartnerUsage: Symbol('operations-partner-usage'),
    PlatformSettings: Symbol('operations-platform-settings'),
    TaxTableGenerator: Symbol('tax-table-generator'),
    Users: Symbol('operations-users'),
};

export const MENU_ADVISOR_ITEMS = {
    AdvisorDashboard: Symbol('advisor-dashboard'),
    Calculators: Symbol('advisor-calculators'),
    Clients: Symbol('advisor-clients'),
    Documents: Symbol('advisor-documents'),
    GuidedPlanner: Symbol('advisor-guided-planner'),
    Members: Symbol('advisor-members'),
    Projects: Symbol('advisor-projects'),
    Settings: Symbol('advisor-settings'),
    TaxSeasonDashboard: Symbol('tax-season-dashboard'),
    GiftTaxDashboard: Symbol('gift-tax-dashboard'),
    TeamManagement: Symbol('team-management'),
    WorkspaceOverview: Symbol('advisor-workspace-overview'),
};

export const MENU_USER_ITEMS = {
    Calculators: Symbol('calculators'),
    Dashboard: Symbol('dashboard'),
    Documents: Symbol('documents'),
    GuidedPlanner: Symbol('guided-planner'),
    KnowledgeLibrary: Symbol('knowledge-library'),
    Messages: Symbol('messages'),
    Notifications: Symbol('notifications'),
    Onboarding: Symbol('onboarding'),
    OilGasQuestionnaire: Symbol('oil-gas-questionnaire'),
    Projects: Symbol('projects'),
    RiskAnalysis: Symbol('risk-analysis'),
    SavedProjects: Symbol('saved-projects'),
    Scenarios: Symbol('scenarios'),
    SolarActivities: Symbol('solar-activities'),
    SolarProjects: Symbol('solar-projects'),
    Tasks: Symbol('tasks'),
};

// The dashboard "Projects" and "Scenarios" sections preview a single row of cards
// before a "View all" link appears (linking to the full /projects/ or /scenarios/
// page). The grids are 3-up by default and 4-up at the `3xl` breakpoint, so both the
// number of cards shown and the "View all" threshold track the column count.
export const DASHBOARD_ROW_SIZE = 3;
export const DASHBOARD_ROW_SIZE_WIDE = 4;

// Number of placeholder cards shown in "Discover more strategies" while the
// dashboard playlist loads (each renders DashboardArticleCard's skeleton state).
export const DASHBOARD_STRATEGY_SKELETON_COUNT = 3;

// Viewport width (px) at/above which the dashboard card grids switch from 3 to 4
// columns. Keep in sync with the Tailwind `3xl` screen in tailwind.config.js.
export const WIDE_DESKTOP_BREAKPOINT = 1920;

// Viewport floors and analytics bands live in services/viewport.js — that module is kept
// import.meta.env-free so the e2e specs can import it from plain Node.

export const PRODUCT_DISPLAY_NAMES = {
    crut: 'CRUT',
    qoz: 'QOZ',
    qsbs: 'QSBS',
    'exchange-fund': 'Exchange Fund',
    dst: 'DST',
    solar: 'Solar',
    'oil-gas': 'OIL-GAS',
    grat: 'GRAT',
    ilit: 'ILIT',
    idgt: 'IDGT',
    ngt: 'NGT',
    slat: 'SLAT',
    crummey: 'CRUMMEY',
    clat: 'CLAT',
    ppli: 'PPLI',
};

export const CRUT_DEFAULT_PAYOUT = 0.035;
export const CRUT_PAYOUT_DEBOUNCE_DELAY = 300;
export const CAPITAL_GAINS_DEFAULT_PAYOUT = 0.035;
export const CAPITAL_GAINS_DEFAULT_GROWTH = 1.035;
export const CAPITAL_GAINS_DISTRIBUTION_DEBOUNCE = 1000;
export const CAPITAL_GAINS_DEFAULT_INITIAL_VALUE = 1400000;
export const CAPITAL_GAINS_DEFAULT_AGE = 41;
export const CAPITAL_GAINS_DEFAULT_STATE = 'California';
export const CAPITAL_GAINS_DEFAULT_COST_BASIS = 100000;
export const CAPITAL_GAINS_DEFAULT_FILING_STATUS = 'married_filing_jointly';
export const CAPITAL_GAINS_DEFAULT_CAP_GAINS_RATE = 6;
export const CAPITAL_GAINS_DEFAULT_DIVIDENDS_RATE = 2;
export const CLAT_DEFAULT_CURRENT_VALUE = 1000000;
export const CLAT_DEFAULT_COST_BASIS = 100000;
export const CLAT_DEFAULT_CAP_GAINS_RATE = 7;
export const CLAT_DEFAULT_DIVIDENDS_RATE = 1;
export const CLAT_DEFAULT_GROWTH_RATE = 7;
export const CLAT_DEFAULT_TERM = 20;
export const CLAT_DEFAULT_AGE = 45;
export const CLAT_DEFAULT_STATE = 'California';
export const CLAT_DEFAULT_FILING_STATUS = 'married_filing_jointly';
export const CLAT_DEFAULT_SELL_REMAINDER = true;
export const CLAT_DEFAULT_BENEFICIARY = 'myself';
export const CLAT_TERM_MIN = 10;
export const CLAT_TERM_MAX = 40;
export const COMPARISON_MAX_PRODUCTS = 3;
// CRUT length type constants
export const CRUT_LENGTH_TERM_OF_YEARS = 'term_of_years';
export const CRUT_LENGTH_SIMPLE_LIFETIME = 'simple_lifetime';
export const CRUT_LENGTH_HEDGED_LIFETIME = 'hedged_lifetime';
export const CRUT_LENGTH_LIFETIME_PLUS_TERM = 'lifetime_plus_term';
export const CRUT_LENGTH_TWO_LIFETIMES = 'two_lifetimes';
export const CRUT_LENGTH_HEDGED_TWO_LIFETIMES = 'hedged_two_lifetimes';
export const CRUT_LENGTH_TWO_LIFETIMES_PLUS_TERM = 'two_lifetimes_plus_term';

// QSBS-stacked CRUTs are hardcoded to a 5-year term-of-years per Valur's
// quantitative modeling (see OnboardingProfileCrutQsbsStacking.vue "Trust length" step).
export const QSBS_CRUT_DEFAULT_TERM_YEARS = 5;

export const CRUT_TWO_LIFE_LENGTHS = [
    CRUT_LENGTH_TWO_LIFETIMES,
    CRUT_LENGTH_HEDGED_TWO_LIFETIMES,
    CRUT_LENGTH_TWO_LIFETIMES_PLUS_TERM,
];

export const CRUT_PLUS_TERM_LENGTHS = [CRUT_LENGTH_LIFETIME_PLUS_TERM, CRUT_LENGTH_TWO_LIFETIMES_PLUS_TERM];

export const CRUT_TRUST_LENGTHS = {
    [CRUT_LENGTH_TERM_OF_YEARS]: 'Term of years',
    [CRUT_LENGTH_SIMPLE_LIFETIME]: 'Simple lifetime',
    [CRUT_LENGTH_HEDGED_LIFETIME]: 'Hedged lifetime',
    [CRUT_LENGTH_LIFETIME_PLUS_TERM]: 'Lifetime + term',
    [CRUT_LENGTH_TWO_LIFETIMES]: 'Two lifetimes',
    [CRUT_LENGTH_HEDGED_TWO_LIFETIMES]: 'Hedged two lifetimes',
    [CRUT_LENGTH_TWO_LIFETIMES_PLUS_TERM]: 'Two lifetimes + term',
};
export const CRUT_TRUST_STRATEGIES = {
    flip_crut: 'Flip CRUT',
    nimcrut: 'NIMCRUT',
    standard_crut: 'Standard CRUT',
};

// The staff handbook (docs/help/admin, served behind Cloudflare Access).
export const HELP_CENTER_ADMIN_URL = 'https://help.valur.team/admin';
export const CALENDLY_BOOKING_URL = 'https://valur.com/forms/schedule';
export const CALENDLY_GRAT_URL = 'https://calendly.com/d/29c-wzn-mvd/grat-trust';
export const CALENDLY_TRUST_SIGNING_URL = 'https://calendly.com/d/ch5-yhd-53h/valur-trust-signing';
export const CALENDLY_SOLAR_QUESTIONS_URL = 'https://calendly.com/d/2ft-hzb-hxq/solar-tax-credits';
export const CURRENT_TAX_YEAR = 2026; // This should change manually when we switch to a new tax year
export const LIFETIME_LOWER_BOUND = 27;
export const LIFETIME_UPPER_BOUND = 90;
export const LAST_YEAR = getYearNumber() - 1;

export const ADVISORY_PARTNER_MEMBER_ROLES = {
    admin: 'Admin',
    member: 'Member',
};

// Role picker for the members list and the invite modal. `member` reads as
// "Advisor" everywhere in the product; ADVISORY_PARTNER_MEMBER_ROLES above keeps
// the raw model labels, which the profile page still shows.
export const ADVISORY_PARTNER_MEMBER_ROLE_OPTIONS = [
    { label: 'Advisor', value: 'member' },
    { label: 'Admin', value: 'admin' },
];

export const CONTINGENT_BENEFICIARY_CLOSEST_RELATIVES = 'closest_relatives';
export const CONTINGENT_BENEFICIARY_CHARITIES_BY_TRUSTEE = 'charities_by_trustee';
export const CONTINGENT_BENEFICIARY_SPECIFIC_CHARITY = 'specific_charity';
export const CONTINGENT_BENEFICIARY_SPECIFIC_PERSON = 'specific_person';
export const PROPERTY_FUNDING_YOUR_SEPARATE = 'your_separate_property';

export const SLANT_SPOUSE_LIVING = 'living';
export const SLANT_SPOUSE_FUTURE = 'future';
export const SLANT_SPOUSE_NONE = 'none';

export const CONTINGENT_BENEFICIARIES = [
    { key: CONTINGENT_BENEFICIARY_CLOSEST_RELATIVES, title: 'Your closest-living relatives' },
    {
        key: CONTINGENT_BENEFICIARY_CHARITIES_BY_TRUSTEE,
        title: 'The charities that the Trustee selects, taking into account the charities you support.',
    },
    { key: CONTINGENT_BENEFICIARY_SPECIFIC_CHARITY, title: 'A specific charity' },
    { key: CONTINGENT_BENEFICIARY_SPECIFIC_PERSON, title: 'A specific person' },
];

export const VALUR_SUCCESSOR_TRUSTEE_NAME = 'Valur Charitable Advisors, LLC';

export const GRAT_EXISTING_REMAINDER_TRUST = 'existing_remainder_trust';
export const GRAT_INDIVIDUAL_BENEFICIARIES = 'individual_beneficiaries';
export const GRAT_REMAINDER_TRUST = 'remainder_trust';
export const GRAT_BENEFICIARY_TYPES = {
    // [GRAT_REMAINDER_TRUST]: 'Trust for beneficiary',
    [GRAT_EXISTING_REMAINDER_TRUST]: 'Trust beneficiary',
    [GRAT_INDIVIDUAL_BENEFICIARIES]: 'Individual beneficiary',
};

export const GRAT_MIN_TRUST_LENGTH_YEARS = 2;

export const GRAT_RECURRING_INTERVAL_QUARTERLY = 'quarterly';
export const GRAT_RECURRING_INTERVAL_SEMI_ANNUALLY = 'semi_annually';
export const GRAT_RECURRING_INTERVAL_ANNUALLY = 'annually';
export const GRAT_RECURRING_INTERVALS = {
    [GRAT_RECURRING_INTERVAL_QUARTERLY]: 'Every 3 months',
    [GRAT_RECURRING_INTERVAL_SEMI_ANNUALLY]: 'Every 6 months',
    [GRAT_RECURRING_INTERVAL_ANNUALLY]: 'Every 12 months',
};

export const GRAT_RECURRING_STATUS_DRAFT = 'draft';
export const GRAT_RECURRING_STATUS_ACTIVE = 'active';
export const GRAT_RECURRING_STATUS_PAUSED = 'paused';
export const GRAT_RECURRING_STATUS_CANCELLED = 'cancelled';
export const GRAT_RECURRING_STATUS_SKIPPED = 'skipped';
export const GRAT_RECURRING_STATUSES = {
    [GRAT_RECURRING_STATUS_DRAFT]: 'Draft',
    [GRAT_RECURRING_STATUS_ACTIVE]: 'Active',
    [GRAT_RECURRING_STATUS_PAUSED]: 'Paused',
    [GRAT_RECURRING_STATUS_CANCELLED]: 'Cancelled',
    [GRAT_RECURRING_STATUS_SKIPPED]: 'Skipped',
};

// Who set the recurrence up. Mirrors backend choices.GratRecurringInitiatedBy and decides
// who may act on a pending draft: advisor-initiated recurrences are the advisor's call, and
// the API rejects the client with "This action is managed by your advisor."
export const GRAT_RECURRING_INITIATED_BY_ADVISOR = 'advisor';
export const GRAT_RECURRING_INITIATED_BY_CLIENT = 'client';
export const GRAT_RECURRING_INITIATED_BY_ADMIN = 'admin';

export const GRAT_TRIGGER_MONITORING = 'monitoring';
export const GRAT_TRIGGER_GAIN = 'triggered_gain';
export const GRAT_TRIGGER_LOSS = 'triggered_loss';
export const GRAT_TRIGGER_SWAP_PENDING = 'swap_pending';
export const GRAT_TRIGGER_SWAP_COMPLETE = 'swap_complete';
export const GRAT_TRIGGER_DISABLED = 'disabled';
export const GRAT_TRIGGER_STATUS_LABELS = {
    [GRAT_TRIGGER_MONITORING]: 'Monitoring',
    [GRAT_TRIGGER_GAIN]: 'Gain Triggered',
    [GRAT_TRIGGER_LOSS]: 'Loss Triggered',
    [GRAT_TRIGGER_SWAP_PENDING]: 'Swap Pending',
    [GRAT_TRIGGER_SWAP_COMPLETE]: 'Swap Complete',
    [GRAT_TRIGGER_DISABLED]: 'Disabled',
};
export const GRAT_TRIGGER_STATUS_COLORS = {
    [GRAT_TRIGGER_MONITORING]: 'blue',
    [GRAT_TRIGGER_GAIN]: 'green',
    [GRAT_TRIGGER_LOSS]: 'red',
    [GRAT_TRIGGER_SWAP_PENDING]: 'yellow',
    [GRAT_TRIGGER_SWAP_COMPLETE]: 'gray',
    [GRAT_TRIGGER_DISABLED]: 'gray',
};

export const GRAT_ANNUITY_PENDING = 'pending';
export const GRAT_ANNUITY_HEADSUP_SENT = 'heads_up_sent';
export const GRAT_ANNUITY_ACTION_SENT = 'action_sent';
export const GRAT_ANNUITY_FOLLOWUP_SENT = 'followup_sent';
export const GRAT_ANNUITY_CONFIRMED = 'confirmed';
export const GRAT_ANNUITY_SUPPRESSED = 'suppressed';
export const GRAT_ANNUITY_STATUS_LABELS = {
    [GRAT_ANNUITY_PENDING]: 'Pending',
    [GRAT_ANNUITY_HEADSUP_SENT]: 'Heads-up Sent',
    [GRAT_ANNUITY_ACTION_SENT]: 'Action Required',
    [GRAT_ANNUITY_FOLLOWUP_SENT]: 'Follow-up Sent',
    [GRAT_ANNUITY_CONFIRMED]: 'Confirmed',
    [GRAT_ANNUITY_SUPPRESSED]: 'Suppressed',
};
export const GRAT_ANNUITY_STATUS_COLORS = {
    [GRAT_ANNUITY_PENDING]: 'gray',
    [GRAT_ANNUITY_HEADSUP_SENT]: 'blue',
    [GRAT_ANNUITY_ACTION_SENT]: 'yellow',
    [GRAT_ANNUITY_FOLLOWUP_SENT]: 'orange',
    [GRAT_ANNUITY_CONFIRMED]: 'green',
    [GRAT_ANNUITY_SUPPRESSED]: 'gray',
};

export const TRUST_RELATION_EXTERNAL = 'external_trust';
export const TRUST_RELATION_INTERNAL = 'internal_trust';
export const TRUST_RELATION_NEW = 'new_trust';

export const DISTRIBUTION_SCHEDULE_MONTHLY = 'monthly';
export const DISTRIBUTION_SCHEDULE_QUARTERLY = 'quarterly';
export const DISTRIBUTION_SCHEDULE_ANNUALLY = 'annually';

export const DISTRIBUTION_SCHEDULES = [
    { key: DISTRIBUTION_SCHEDULE_MONTHLY, title: 'Monthly' },
    { key: DISTRIBUTION_SCHEDULE_QUARTERLY, title: 'Quarterly' },
    { key: DISTRIBUTION_SCHEDULE_ANNUALLY, title: 'Annually' },
];

// Drives the progress percentage, the hours remaining and the pace note on the Material
// Participation Log. Never print it: no copy may name the hour count (ENG-948, ENG-3224).
export const MATERIAL_PARTICIPATION_TARGET_HOURS = 100;

export const SOLAR_ACTIVITY_CATEGORY_BOOKKEEPING = 'bookkeeping';
export const SOLAR_ACTIVITY_CATEGORY_CONTRACTOR_COORDINATION = 'contractor_coordination';
export const SOLAR_ACTIVITY_CATEGORY_DUE_DILIGENCE = 'due_diligence';
export const SOLAR_ACTIVITY_CATEGORY_EDUCATION = 'education';
export const SOLAR_ACTIVITY_CATEGORY_IN_PERSON_MEETING = 'in_person_meeting';
export const SOLAR_ACTIVITY_CATEGORY_MANAGEMENT_CALL = 'management_call';
export const SOLAR_ACTIVITY_CATEGORY_OTHER = 'other';
export const SOLAR_ACTIVITY_CATEGORY_PROJECT_PARTICIPATION = 'project_participation';
export const SOLAR_ACTIVITY_CATEGORY_RESEARCH = 'research';
export const SOLAR_ACTIVITY_CATEGORY_SITE_VISIT = 'site_visit';
export const SOLAR_ACTIVITY_CATEGORIES = {
    [SOLAR_ACTIVITY_CATEGORY_DUE_DILIGENCE]: 'Due diligence',
    [SOLAR_ACTIVITY_CATEGORY_EDUCATION]: 'Education',
    [SOLAR_ACTIVITY_CATEGORY_IN_PERSON_MEETING]: 'In-person meeting',
    [SOLAR_ACTIVITY_CATEGORY_MANAGEMENT_CALL]: 'Management call',
    [SOLAR_ACTIVITY_CATEGORY_BOOKKEEPING]: 'Bookkeeping',
    [SOLAR_ACTIVITY_CATEGORY_CONTRACTOR_COORDINATION]: 'Contractor coordination',
    [SOLAR_ACTIVITY_CATEGORY_PROJECT_PARTICIPATION]: 'Project participation',
    [SOLAR_ACTIVITY_CATEGORY_RESEARCH]: 'Research',
    [SOLAR_ACTIVITY_CATEGORY_SITE_VISIT]: 'Site visit',
    [SOLAR_ACTIVITY_CATEGORY_OTHER]: 'Other',
};
// The six types the Log an activity modal offers (ENG-3224). Legacy categories stay valid and
// keep displaying; education is for video rows and due diligence for calendar rows.
export const MATERIAL_PARTICIPATION_ACTIVITY_TYPES = [
    SOLAR_ACTIVITY_CATEGORY_SITE_VISIT,
    SOLAR_ACTIVITY_CATEGORY_MANAGEMENT_CALL,
    SOLAR_ACTIVITY_CATEGORY_BOOKKEEPING,
    SOLAR_ACTIVITY_CATEGORY_CONTRACTOR_COORDINATION,
    SOLAR_ACTIVITY_CATEGORY_RESEARCH,
    SOLAR_ACTIVITY_CATEGORY_OTHER,
];
// The line under the type pills that describes the selected type. It names no hour target, the
// IRS or "investment" (ENG-948, ENG-2048).
export const MATERIAL_PARTICIPATION_ACTIVITY_HINTS = {
    [SOLAR_ACTIVITY_CATEGORY_SITE_VISIT]: 'Time at a project site, such as inspections and walkthroughs',
    [SOLAR_ACTIVITY_CATEGORY_MANAGEMENT_CALL]: 'Calls with the developer, operator or asset manager about a project',
    [SOLAR_ACTIVITY_CATEGORY_BOOKKEEPING]: "Reviewing a project's statements, invoices and records",
    [SOLAR_ACTIVITY_CATEGORY_CONTRACTOR_COORDINATION]:
        'Working with installers, contractors and suppliers on a project',
    [SOLAR_ACTIVITY_CATEGORY_RESEARCH]: "Studying a project's documents, reports or market",
    [SOLAR_ACTIVITY_CATEGORY_OTHER]: 'Any other work you do on your projects',
};
export const SOLAR_BONUS_DEPRECIATION_SHARE_1Y = 1;
export const SOLAR_OWNERSHIP_PERCENTAGE = 0.99;

export const SOLAR_PAYMENT_STRUCTURE_DISPLAY = {
    '100_upfront': '100% upfront payment',
    '50_50': '50% down, 50% upon completion',
    '25_75': '25% down, 75% upon completion',
};

export const SOLAR_PROJECT_AVAILABILITY_AVAILABLE = 'available';
export const SOLAR_PROJECT_AVAILABILITY_NOT_AVAILABLE = 'not_available';
export const SOLAR_PROJECT_AVAILABILITY_RESERVED = 'reserved';
export const SOLAR_PROJECT_AVAILABILITY_OPTIONS = {
    [SOLAR_PROJECT_AVAILABILITY_AVAILABLE]: 'Available',
    [SOLAR_PROJECT_AVAILABILITY_NOT_AVAILABLE]: 'Not available',
    [SOLAR_PROJECT_AVAILABILITY_RESERVED]: 'Reserved',
};

export const SOLAR_PROJECT_PURCHASE_MINIMUM = 100000;
export const SOLAR_PROJECT_TYPE_FLIP_PARTNERSHIP = 'flip_partnership';
export const SOLAR_PROJECT_TYPE_PPA = 'ppa';
export const SOLAR_PROJECT_TYPE_SALE_LEASEBACK = 'sale_leaseback';
export const SOLAR_PROJECT_TYPES = {
    [SOLAR_PROJECT_TYPE_SALE_LEASEBACK]: 'Sale-leaseback',
    [SOLAR_PROJECT_TYPE_FLIP_PARTNERSHIP]: 'Flip partnership',
};

export const SOLAR_PROJECT_OWNERSHIP_STRUCTURES = {
    [SOLAR_PROJECT_TYPE_FLIP_PARTNERSHIP]: 'Flip partnership',
    [SOLAR_PROJECT_TYPE_PPA]: 'PPA',
    [SOLAR_PROJECT_TYPE_SALE_LEASEBACK]: 'Sale leaseback',
};
export const SOLAR_PROJECT_TYPE_TOOLTIPS = {
    [SOLAR_PROJECT_TYPE_SALE_LEASEBACK]:
        'A sale-leaseback is the simplest approach to renewable energy ' +
        'participation. In this model, you provide capital and own a project outright. You capture the tax ' +
        'benefits on your full purchase, and you earn income — typically 5% of your purchase amount annually ' +
        'for 20 years.',
    [SOLAR_PROJECT_TYPE_FLIP_PARTNERSHIP]:
        'In this model, you provide capital and the developer (and, ' +
        'sometimes, a bank) offer matching funds. You capture the tax benefits on the full project value — ' +
        'often as much as 2.6 times your purchase amount — but the developer and the bank earn most of the ' +
        'income from the project.',
};

export const DOCUMENT_TYPE_ADDITIONAL_DOCUMENTS = 'additional_documents';
export const DOCUMENT_TYPE_ID_DOCUMENT = 'id_document';
export const DOCUMENTS_TRUST_AGREEMENT = 'trust_agreement';

// Document types that count as a government-issued identification. Mirrors the
// backend `User.has_identification` check (registration/api/user.py). Kept as a list
// so the ID step can list every matching doc, and so adding a new ID type (e.g.
// passport, state ID) here — alongside the matching backend change — broadens the
// match in one place.
export const IDENTIFICATION_DOCUMENT_TYPES = [DOCUMENT_TYPE_ID_DOCUMENT];

export const GUIDED_PLANNER_VISIBILITY_THRESHOLD = 'md';

// Offset multiplier for chart lines to prevent overlapping tooltips
export const CHART_JITTER_OFFSET = 0.02;

// CRUT Calculator constants
export const CRUT_MIN_FLIP_YEAR = 5;
export const CRUT_MAX_FLIP_YEAR_OPTIONS = 3;
export const CRUT_FLIP_YEAR_INCREMENT = 5;

export const AVAILABLE_ANIMATIONS = {
    SLIDE_RIGHT: 'slideRight',
    SLIDE_LEFT: 'slideLeft',
    SLIDE_UP: 'slideUp',
    SLIDE_DOWN: 'slideDown',
    EXPAND_OUT: 'expandOut',
    SHRINK_DOWN: 'shrinkDown',
    FADE_IN: 'fadeIn',
    FADE_OUT: 'fadeOut',
    EMPTY: '',
};
export const ANIMATION_LENGTHS = {
    short: 200,
    medium: 450,
    long: 800,
};

export const ARTICLE_EXCERPT_MAX_LENGTH = 200;
export const TAILWIND_COLORS_DEV = ['gray', 'indigo', 'green', 'red'];
export const TAILWIND_COLORS_PROD = [
    'zinc',
    'neutral',
    'stone',
    'orange',
    'amber',
    'yellow',
    'lime',
    'emerald',
    'teal',
    'cyan',
    'sky',
    'blue',
    'violet',
    'purple',
    'fuchsia',
    'pink',
    'rose',
];

export const NOTIFICATION_VISIBILITY_DURATION_SHORT = 2000;
export const NOTIFICATION_VISIBILITY_DURATION_NORMAL = 3000;
export const NOTIFICATION_VISIBILITY_DURATION_LONG = 5000;

export const HUBSPOT_DEAL_EXPLORATION_STAGE = 'Exploration';
export const HUBSPOT_PRODUCT_INTEREST_CRUT = 'CRUT';
export const HUBSPOT_PRODUCT_INTEREST_SOLAR = 'Solar';
export const HUBSPOT_PRODUCT_INTEREST_OIL_AND_GAS = 'Oil & Gas';
export const HUBSPOT_PRODUCT_INTEREST_CRUMMEY = ['Crummey', 'Crummey Trust'];
export const HUBSPOT_PRODUCT_INTEREST_GRAT = 'GRAT';
export const HUBSPOT_SUPPORTED_PRODUCT_INTERESTS = [
    HUBSPOT_PRODUCT_INTEREST_CRUT,
    ...HUBSPOT_PRODUCT_INTEREST_CRUMMEY,
    HUBSPOT_PRODUCT_INTEREST_GRAT,
];
export const isProductSupported = productKey => {
    if (typeof productKey !== 'string' || !productKey.trim()) {
        return false;
    }
    if (typeof productKey !== 'string' || !productKey.trim()) {
        return false;
    }
    const keys = productKey.split(';').map(k => k.trim().toLowerCase());
    return keys.some(key => HUBSPOT_SUPPORTED_PRODUCT_INTERESTS.some(supported => supported.toLowerCase() === key));
};

export const MESSAGE_CENTER_MESSAGE_TYPE_USER = 'user';
export const MESSAGE_CENTER_MESSAGE_TYPE_SUPPORT = 'support';
export const MESSAGE_CENTER_MESSAGE_TYPE_SYSTEM = 'system';
export const MESSAGE_CENTER_MESSAGE_TYPES = {
    [MESSAGE_CENTER_MESSAGE_TYPE_USER]: 'User Message',
    [MESSAGE_CENTER_MESSAGE_TYPE_SUPPORT]: 'Support Message',
    [MESSAGE_CENTER_MESSAGE_TYPE_SYSTEM]: 'System Message',
};

export const SLACK_DEV_TEST_CHANNEL = 'dev-test';
export const SLACK_OPS_CUSTOMER_ACTIVITIES_CHANNEL = 'ops_customer_activities';
export const SLACK_OPS_CUSTOMER_MESSAGES_CHANNEL = 'ops_customer_messages';

export const DON_NOT_EXCLUDE_SUFFIX = '__do_not_exclude';

export const NUMBER_FORMAT_MILLION = 1000000;
export const NUMBER_FORMAT_BILLION = 1000000000;
export const NUMBER_FORMAT_SUFFIX_MILLION = 'M';
export const NUMBER_FORMAT_SUFFIX_BILLION = 'B';

export const LIFE_EXPECTANCY = {
    26: 59,
    27: 58,
    28: 57,
    29: 56,
    30: 55,
    31: 54,
    32: 53,
    33: 53,
    34: 52,
    35: 51,
    36: 50,
    37: 49,
    38: 48,
    39: 47,
    40: 46,
    41: 45,
    42: 44,
    43: 43,
    44: 42,
    45: 41,
    46: 40,
    47: 39,
    48: 38,
    49: 37,
    50: 36,
    51: 35,
    52: 34,
    53: 33,
    54: 33,
    55: 32,
    56: 31,
    57: 30,
    58: 29,
    59: 28,
    60: 27,
    61: 26,
    62: 25,
    63: 25,
    64: 24,
    65: 23,
    66: 22,
    67: 21,
    68: 20,
    69: 20,
    70: 19,
    71: 18,
    72: 17,
    73: 16,
    74: 16,
    75: 15,
    76: 14,
    77: 13,
    78: 13,
    79: 12,
    80: 11,
    81: 11,
    82: 10,
    83: 9,
    84: 9,
    85: 8,
    86: 8,
    87: 6,
    88: 7,
    89: 7,
    90: 6,
};

// Reachable from plain Node, where `import.meta.env` is undefined: the e2e specs import
// services directly and one of those may pull this module in. Reading through an alias keeps
// that from throwing — a backstop, not a licence, since the alias is empty there and every
// value derived from it is then wrong rather than absent. An alias and not a destructure, so
// Vite's static replacement still applies.
const VITE_ENV = import.meta.env ?? {};

export const isProduction = () => {
    return VITE_ENV.VITE_ENVIRONMENT === 'production';
};

// Skattly (tax tables) dev root. In a Caddy-routed worktree
// (`<svc>.<slug>.localhost`) the service's port isn't published, so it is only
// reachable through the proxy at its sibling hostname (mirrors store/api.js's
// rootFor); plain-localhost dev keeps the direct port.
const skattlyDevRoot = () => {
    const { protocol, hostname } = (typeof window !== 'undefined' && window.location) || {};
    const worktree = (hostname || '').match(/^[a-z0-9-]+\.([a-z0-9-]+)\.localhost$/);
    if (worktree) return `${protocol}//skattly.${worktree[1]}.localhost`;
    return 'http://localhost:8080';
};

export const SKATTLY_API_ROOT =
    VITE_ENV.VITE_SKATTLY_API_ROOT ||
    (VITE_ENV.VITE_ENVIRONMENT === 'development' || VITE_ENV.VITE_ENVIRONMENT === 'dev'
        ? skattlyDevRoot()
        : 'https://skattly.valur.com');

export const CRUT_NOTIFICATION = {
    CHANNEL: 'dev-notifications',
    DEBOUNCE_DELAY: 2000,
    SCENARIOS: {
        LIFETIME: true,
        MAX_LENGTH: true,
        TERM: false,
    },
    TIMEZONE: 'America/Los_Angeles',
    TIMEZONE_LABEL: 'PST',
};

export const CRUT_THRESHOLDS = {
    MIN_DIFFERENCE_PERCENT: 5,
    MAX_DIFFERENCE_PERCENT: 90,
    MIN_DISTRIBUTION_AMOUNT: 1000,
    ZERO_DISTRIBUTION_THRESHOLD: 10,
    HIGH_GROWTH_THRESHOLD: 30,
};
